export const DEFAULT_PAGINATION = 'page=1&per_page=&search=&category=&sort=&direction=';
// Always leave demo.realgeeks.com in Beta "42cc1d70-c912-11e0-8a75-001cc45fad02"
export const BETA_SITE_UUIDS = [
    "42cc1d70-c912-11e0-8a75-001cc45fad02",
    "972248e5-dc8a-466a-ba8f-ad5aaf20a4e9",
    "a8d7ec6b-61ab-4af5-9ee9-60e353e47371",
    "5a34f5a9-3397-45b3-ba33-98061b21ea5f",
    "424280a3-34df-4173-93cf-6ff6064c7726",
    "5513fdda-b5df-41e8-a9dd-9170dd7d0525",
    "25fa1d63-438f-4954-a74b-235b364da8ce",
    "665ef056-8e3a-4e4c-9446-3564adb41f92",
    "f8e1971e-55cd-4a4c-b5f8-9b988b71b87e",
    "e03e3d1b-7d7d-4a1e-8c80-467dd4b37bf7"
    ]
export const GEEK_AI_SYSTEM_SOURCES = process.env.GEEK_AI_SYSTEM_SOURCES || {
  "Website Agent Landing Page": ["Website Agent Landing Page"],
  "Website Property Valuation Agent Landing Page": ["Website Property Valuation Agent Landing Page"],
  "Website Property Landing Page": ["Website Property Landing Page"],
  "Website Market Report Page": ["Website Market Report Page"],
  "Website Coming Soon Landing Page": ["Website Coming Soon Landing Page"],
  "Website Custom Capture Form": ["Website Custom Capture Form"],
  "Traffic Blaster": ["Traffic Blaster"],
  "Facebook Lead Ads": ["Facebook Lead Ads"],
  "RG Facebook Lead Ads": ["RG Facebook Lead Ads"],
  "RG FB Tool Lead Ad": ["RG FB Tool Lead Ad"],
  "Website Property Search": ["Website Property Search"],
  "Website Property Valuation": ["Website Property Valuation"],
  "Georgia Down Payment": ["Georgia Down Payment"],
  "Homes": ["Homes.com"],
  "Kunversion": ["Kunversion"],
  "Movoto": ["Movoto"],
  "Zillow": ["zillow"],
  "Trulia": ["trulia.com"],
  "realtor.com": ["realtor.com"],
  "Google": ["Google"],
  "Google PPC": ["Google PPC"],
  "Facebook": ["Facebook", "fb"]
}
